import React, { useState, useEffect } from 'react';
import '../../../../Assets/Css/EmpProjectActivity.scss';
import { getTasks } from '../../../../Services/Task/action';
import { connect } from 'react-redux';
import { getprojects } from '../../../../Services/Project/action';
import moment from 'moment';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { customStyle } from '../../../../Components/Style';
import { generateYearOptions, Month, activityStyles, projectActivity } from '../../../../Lib/utils';
import { useParams } from 'react-router-dom';

const EmpProjectActivity = (props) => {
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userIds, setUserIds] = useState([]);
  const [filters, setFilters] = useState({
    Year: '',
    Month: '',
  });
  const Year = generateYearOptions();
  const year = filters?.Year?.value ? parseInt(filters?.Year?.value) : new Date().getFullYear();
  const month = filters?.Month?.value ? new Date(`${filters?.Month?.value} 1, ${year || currentDate.year()}`).getMonth() + 1 : new Date().getMonth() + 1;
  const today = new Date().getDate();
  const { projectId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      await props?.getTasks();
      await props?.getprojects();
      setLoading(false);
    }

    fetchData();
  }, []);


  useEffect(() => {
    if (props?.project && props?.task) {
      const filteredProject = props?.project?.filter(item => item?.id == projectId);

      if (filteredProject?.[0]?.projectUserMap) {
        const assignedUsers = filteredProject?.[0]?.projectUserMap?.filter(entry => props?.task?.some(task => task?.project?.id == filteredProject?.[0]?.id))
          ?.map(entry => entry.user_id);
        setUserIds(assignedUsers);
      }
    }
  }, [props?.project, props?.task])

  const formattedDate = selectedDate?.split(" ")[0];

  const taskTimerActivities = Array?.isArray(props?.task) ? props?.task?.filter(task =>
    Array.isArray(task?.taskUserMap) && task?.taskUserMap?.some(mapping => userIds?.includes(mapping?.user_id)))?.flatMap(task => {

      const timerActivities = task?.taskTimerMap?.filter(item => moment(item?.start_time?.split(" ")?.[0])?.format('DD-MM-YYYY') == formattedDate)?.flatMap(timer => {
        let history = [];
        try {
          history = JSON.parse(timer?.action_history || '[]');
        } catch (err) {
          console.error('Failed to parse action_history:', err);
        }
        let parsedHistory = [];
        if (typeof actions === 'string') {
          try {
            parsedHistory = JSON.parse(history);
          } catch (err) {
            console.error("Failed to parse history string:", err);
            parsedHistory = [];
          }
        } else {
          parsedHistory = Array.isArray(history) ? history : [];
        }
        return parsedHistory?.map(actionObj => ({
          time: actionObj?.time?.split(" ")[1],
          type: `${actionObj?.action?.charAt(0).toUpperCase() + actionObj?.action?.slice(1)} Timer`,
          employeeactivity: task?.title,
        }));
      }) || [];

      return timerActivities;
    }) : [];

  const taskActivities = Array?.isArray(props?.task) ? props?.task?.filter(task =>
    Array.isArray(task?.taskUserMap) && task?.taskUserMap?.some(mapping => userIds?.includes(mapping?.user_id)))?.flatMap(task => {
      const taskDate = moment(task?.createdAt).format('DD-MM-YYYY');
      if (taskDate !== formattedDate) return [];
      const baseActivity = [];

      baseActivity.push({
        time: task?.createdAt?.split(" ")?.[1],
        type: 'Create Task',
        employeeactivity: task?.title,
      });

      if (task?.status === 'Completed') {
        baseActivity.push({
          time: task?.updated_status_at?.split(" ")?.[1],
          type: 'Complete Task',
          employeeactivity: task?.title,
        });
      }



      return baseActivity;
    }) : [];

  const activities = [...taskActivities, ...taskTimerActivities];

  const calculateDaysInMonth = (month, year) => {
    return new Date(year, month, 0).getDate();
  };

  useEffect(() => {
    const days = calculateDaysInMonth(month, year);
    const daysArray = Array.from({ length: days }, (_, index) => {
      const date = new Date(year, month - 1, index + 1);
      return { day: index + 1, dayName: date.toLocaleDateString('en-US', { weekday: 'short' }) };
    });
    setDaysInMonth(daysArray);

    const todayDate = daysArray.find((day) => day.day === today);
    if (todayDate) {
      dayClick(todayDate);
    }
  }, [month, year]);

  const dayClick = (item) => {
    const selectedFullDate = new Date(year, month - 1, item.day);
    const formattedDate = `${item.day.toString().padStart(2, '0')}-${month
      .toString()
      .padStart(2, '0')}-${year}`;
    const dayName = selectedFullDate.toLocaleDateString('en-US', { weekday: 'long' });
    setSelectedDate(`${formattedDate} - ${dayName}`);
    setSelectedDay(item.day);
  };

  const sortedActivities = activities.sort((a, b) => (a.time > b.time ? 1 : -1));

  const groupActivitiesByHour = (activities) => {
    return activities.reduce((acc, activity) => {
      const hour = activity.time.split(':')[0];
      if (!acc[hour]) {
        acc[hour] = [];
      }
      acc[hour].push(activity);
      return acc;
    }, {});
  };

  const filteredActivities =
    selectedFilters.length > 0
      ? sortedActivities.filter((activity) => selectedFilters.includes(activity.type))
      : sortedActivities;

  const groupedActivities = groupActivitiesByHour(filteredActivities);
  const defaultHours = ['09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'];

  const toggleFilter = (filter) => {
    setSelectedFilters((prevFilters) => {
      if (prevFilters.includes(filter)) {
        return prevFilters.filter((item) => item !== filter);
      } else {
        return [...prevFilters, filter];
      }
    });
  };

  const applyFilters = ({ month, year }) => {
    const currentDate = moment();
    const formattedMonth = new Date(`${month?.value} 1, ${year || currentDate.year()}`).getMonth() + 1

    const days = calculateDaysInMonth(formattedMonth, parseInt(year));
    const daysArray = Array.from({ length: days }, (_, index) => {
      const date = new Date(year, formattedMonth - 1, index + 1);
      return {
        day: index + 1,
        date,
        dayName: date.toLocaleDateString('en-US', { weekday: 'short' })
      };
    });

    setDaysInMonth(daysArray);
  };

  const handleClear = () => {
    setFilters({
      Year: '',
      Month: '',
    })
    const days = calculateDaysInMonth(month, year);
    const daysArray = Array.from({ length: days }, (_, index) => {
      const date = new Date(year, month - 1, index + 1);
      return { day: index + 1, dayName: date.toLocaleDateString('en-US', { weekday: 'short' }) };
    });
    setDaysInMonth(daysArray);
  }

  return (
    <div className="empActivity-main">
      <div className="row">
        <div className="col-lg-4 col-sm-12">
          <div className="card-type">
            <Select
              value={filters.Month}
              onChange={(data) => {

                setFilters({
                  ...filters,
                  Month: data,
                })
                applyFilters({ month: data, year: year })
              }
              }
              options={Month}
              placeholder={'Month'}
              styles={customStyle}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: '#5757fe',
                  primary: '#5757fe',
                },
              })}
            />
          </div>
        </div>

        <div className="col-lg-4 col-sm-12">
          <div className="card-type">
            <Select
              value={filters.Year}
              onChange={(data) => {

                setFilters({
                  ...filters,
                  Year: data,
                })
                applyFilters({ month: month, year: data })
              }
              }
              options={Year}
              placeholder={'Year'}
              styles={customStyle}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: '#5757fe',
                  primary: '#5757fe',
                },
              })}
            />
          </div>
        </div>
        <div className='col-lg-4 col-sm-12'>

          {(filters?.Month || filters?.Year) && (
            <button
              className="export-btn"
              disabled={props.loading}
              onClick={handleClear}
            >
              {props.loading ? (
                <Spinner as="span" animation="border" role="status" aria-hidden="true" />
              ) : (
                'Clear'
              )}
            </button>
          )}
        </div>
      </div>

      {loading ? (
        <Spinner as="span" animation="border" role="status" aria-hidden="true" />
      ) : (
        <div className="activity-table">
          <div className="days-count">
            <div className="days">
              {daysInMonth?.map((item, idx) => (
                <div
                  className="days-number"
                  key={idx}
                  onClick={() => dayClick(item)}
                  style={{ cursor: 'pointer', color: selectedDay === item?.day ? 'black' : 'gray' }}
                >
                  {item?.dayName.slice(0, 1)}
                  {item?.day}
                </div>
              ))}
            </div>

            <div className="table-details">
              <div className="days">
                {selectedDate && (
                  <div className="selected-date" style={{ gridColumn: 'span ' + daysInMonth.length }}>
                    {selectedDate}
                  </div>
                )}
              </div>

              <div>
                {defaultHours?.map((hour) => (
                  <div className="days" key={hour}>
                    <div className="timer-time">
                      <span>{hour}:00</span>
                    </div>
                    <div className="d-flex gap-3">
                      {groupedActivities[hour]?.length > 0 ? (
                        groupedActivities[hour].map((activity, index) => (
                          <div
                            className="timer-activity"
                            key={index}
                            style={{
                              backgroundColor: activityStyles[activity?.type]?.backgroundColor,
                            }}
                          >
                            <div className="activity-container">
                              <span
                                className="dot"
                                style={{ backgroundColor: activityStyles[activity?.type]?.dotColor }}
                              ></span>
                              <span className="activity-time">{activity?.type}</span>
                              <span className="time">{activity?.time}</span>
                              <span className="task">{activity?.employeeactivity}</span>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div style={{ flexGrow: 1 }}></div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="activity-filter">
                {projectActivity?.map((activity) => (
                  <div
                    key={activity}
                    className={`filter-item ${selectedFilters?.includes(activity) ? 'selected' : ''}`}
                    onClick={() => toggleFilter(activity)}
                    style={{ cursor: 'pointer' }}
                  >
                    <span
                      className="filter-dot"
                      style={{ backgroundColor: activityStyles[activity]?.dotColor }}
                    ></span>
                    <span className="filter-text">{activity}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    task: state.taskReducer.task,
    attendance: state.attendanceReducer.attendance,
    leave: state.leaveReducer.leave,
    project: state.projectReducer.project
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getTasks: () => {
      dispatch(getTasks())
    },
    getprojects: () => {
      dispatch(getprojects())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmpProjectActivity);
